import { Typography, Breadcrumb, Space } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const PageHeader = ({ title, subtitle, breadcrumbs = [], actions }) => {
  const navigate = useNavigate();
  const items = [
    { title: <HomeOutlined onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }} /> },
    ...breadcrumbs.map((b) => ({
      title: b.path ? <span onClick={() => navigate(b.path)} style={{ cursor: 'pointer', color: 'var(--wl-primary)' }}>{b.label}</span> : b.label,
    })),
    { title },
  ];

  return (
    <div style={{ marginBottom: 24 }}>
      <Breadcrumb items={items} style={{ marginBottom: 10 }} />
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#fff',
        borderRadius: 16,
        padding: '14px 20px',
        boxShadow: '0 2px 8px rgba(var(--wl-primary-rgb),0.08)',
        borderLeft: '5px solid var(--wl-primary)',
      }}>
        <div>
          <Title
            level={4}
            style={{
              margin: 0,
              fontFamily: "'Fredoka One', sans-serif",
              color: 'var(--wl-primary)',
              letterSpacing: 0.3,
            }}
          >
            {title}
          </Title>
          {subtitle && (
            <Typography.Text style={{ fontSize: 12, color: 'var(--wl-text-muted)' }}>{subtitle}</Typography.Text>
          )}
        </div>
        {actions && <Space>{actions}</Space>}
      </div>
    </div>
  );
};

export default PageHeader;
